import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ 
  children, 
  requiredRole = null, 
  allowedRoles = [], 
  redirectTo = '/authentication' 
}) => {
  const { user, userProfile, loading, isAuthenticated, getDefaultRoute } = useAuth()
  const location = useLocation()

  // Show loading spinner while authentication state is loading
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center space-y-4">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
          <p className="text-muted-foreground">Loading...</p>
        </div>
      </div>
    )
  }

  // Redirect to authentication if not logged in
  if (!isAuthenticated) {
    return <Navigate to={redirectTo} state={{ from: location }} replace />
  }

  // Wait for user profile to load
  if (!userProfile) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="flex flex-col items-center space-y-4">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
          <p className="text-muted-foreground">Loading profile...</p>
        </div>
      </div>
    )
  }

  const userRole = userProfile?.role

  // Check if user has required role
  if (requiredRole && userRole !== requiredRole) {
    return <Navigate to={getDefaultRoute()} replace />
  }

  // Check if user has one of the allowed roles
  if (allowedRoles?.length > 0 && !allowedRoles?.includes(userRole)) {
    return <Navigate to={getDefaultRoute()} replace />
  }

  // User is authenticated and authorized
  return children
}

export default ProtectedRoute